var addToCartButton = document.querySelector('.add-to-cart');
    addToCartButton.addEventListener('click', function(event) {
    const sizeOptions = document.getElementsByName('Size');
    let sizeSelected = false;

    if (sizeOptions.length === 0) {
        sizeSelected = true;
        return;
    }
    // Check if any size option is selected
    for (const option of sizeOptions) {
        if (option.checked) {
            sizeSelected = true;
            break;
        }
    }
    // Display error message if no size is selected
    const errorMessage = document.getElementById('size-error-message');
    if (!sizeSelected) {
        event.preventDefault();
        errorMessage.style.display = 'block';
    } else {
        errorMessage.style.display = 'none';
    }
});
